import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../config/config.js';
import axios from 'axios';
import EventBus from '../../helpers/EventBus';

class SSPStewardNumber extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stewardNumber: props.stewardNumber || '',
            open: false,
            loading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            stewardNumber: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            stewardNumber: this.props.stewardNumber || '',
            open: true
        });
    }

    handleClose() {
        this.setState({
            open: false
        });
    }

    handleSave() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shift/setShiftSupporterProjectStewardNumber/' + this.props.id, {
            method: 'put',
            data: {
                stewardNumber: this.state.stewardNumber
            }
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                that.setState({
                    loading: false,
                    open: false
                });
                EventBus.dispatch('SupporterEventsBlock-load', {});
                EventBus.dispatch('SupporterShiftsBlock-load', {});
                that.props.handleSaveSuccess();
            } else {
                that.setState({
                    loading: false
                });
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <Popover targetClass="SSPStewardNumber btn btn-xs btn-default"
                     onOpen={this.handleOpen} onClose={this.handleClose} open={this.state.open}
                     contentClass="rap-popover-content">
                <span>
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="#1c84c6"
                         style={{verticalAlign: 'middle'}}>
                        <path d="M8.5 3 L11 6.5 L11 21 L6 21 L4.5 6 L6.5 4 Z"/>
                        <path d="M15.5 3 L13 6.5 L13 21 L18 21 L19.5 6 L17.5 4 Z"/>
                    </svg>
                    {this.props.stewardNumber ? <span className="m-l-xs">{this.props.stewardNumber}</span> : null}
                </span>
                <div className="p-md" style={{width: 220}}>
                    <div className="form-group">
                        <label>{t('supporterShifts.stewardNumber.label')}</label>
                        <input type="text" name="stewardNumber" value={this.state.stewardNumber}
                               onChange={this.handleInputChange} className="form-control"
                               style={{borderColor: '#1c84c6', color: '#1c84c6', fontWeight: 'bold'}}
                               disabled={this.state.loading}/>
                    </div>
                    <button className="btn btn-small btn-primary" onClick={this.handleSave}
                            disabled={this.state.loading}>
                        <i className="fa fa-save m-r-sm"/>
                        {t('default.save')}
                    </button>
                </div>
            </Popover>
        )
    }
}

export default translate()(SSPStewardNumber);
